export default __webpack_public_path__ + "locales/lv/Profile.json?hash=52b5b45eecd3bd9eeb2da24a8cd72c50";